import URI from 'urijs';

export function useIsDevMode() {
  const uri = new URI(window.location.href.toLocaleLowerCase());
  const query = uri.query(true);

  return query.devmode === 'true';
}
